// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ChangeOrdersInlineController from "./change_orders_inline_controller"
application.register("change-orders-inline", ChangeOrdersInlineController)

import InlineFieldController from "./inline_field_controller"
application.register("inline-field", InlineFieldController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ProgressionChartsController from "./progression_charts_controller"
application.register("progression-charts", ProgressionChartsController)
